import cn from 'classnames';

import { DateCardStatus_Theme } from 'source/NFR.types';

import { IDateCardStatus } from 'source/NFR.types';

const themes: Record<number, string> = {
  [DateCardStatus_Theme.None]: '',
  [DateCardStatus_Theme.IsActive]: 'date-card-status--is-active',
  [DateCardStatus_Theme.IsCompleted]: 'date-card-status--is-completed',
  [DateCardStatus_Theme.ResultIsPublished]: 'date-card-status--result-is-published',
  [DateCardStatus_Theme.IsCanceled]: 'date-card-status--is-canceled',
  [DateCardStatus_Theme.IsPlanned]: 'date-card-status--is-planned'
};

interface IDateCardStatusProps extends IDateCardStatus {
  centered?: boolean;
}

const DateCardStatus: React.FC<IDateCardStatusProps> = ({ theme, centered, text }) => (
  <div
    className={cn('date-card-status', theme ? themes[theme] : '', {
      'date-card-status--align-center': centered
    })}
  >
    {text}
  </div>
);

DateCardStatus.displayName = 'DateCardStatus';

export default DateCardStatus;
